import m from "../../es2015/lang/fi_FI";
window.am4lang_fi_FI = m;


//////////////////
// WEBPACK FOOTER
// ./lang/fi_FI.js
// module id = null
// module chunks = 